import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { firebaseConfig } from './index';

const app: FirebaseApp = initializeApp(firebaseConfig);
export const authFirebase: Auth = getAuth(app);
